import { render, staticRenderFns } from "./search.vue?vue&type=template&id=98cc51cc&scoped=true"
import script from "./search.vue?vue&type=script&lang=ts"
export * from "./search.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./search.vue?vue&type=style&index=0&id=98cc51cc&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "98cc51cc",
  "0a58a7b5"
  
)

export default component.exports